import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

import {
  LiqueurFruitFlavor,
  LiqueurFruitHerbal as FruitOrHerbal,
  LiqueurHerbalFlavor,
  LiqueurType,
} from 'src/app/products/interfaces/models';
import { SubformBaseComponent } from 'src/app/shared/components/subform-base/subform-base.component';

import { LiqueurProperties } from '@app/api/models';

@Component({
  selector: 'app-liqueur-properties-subform',
  templateUrl: './liqueur-properties-subform.component.html',
  styleUrls: ['./liqueur-properties-subform.component.scss'],
})
export class LiqueurPropertiesSubformComponent extends SubformBaseComponent {
  DICT_PATH = 'PRODUCTS.LIQUEUR_PROPERTIES';

  fruitFlavors = LiqueurFruitFlavor;
  fruitOrHerbal = FruitOrHerbal;
  herbalFlavors = LiqueurHerbalFlavor;
  types = LiqueurType;

  static buildForm(fb: FormBuilder, data?: LiqueurProperties) {
    return fb.group({
      type: [data?.type, Validators.required],
      fruitOrHerbal: [data?.fruitOrHerbal, Validators.required],
      // fruitFlavor:
      ...(data?.fruitOrHerbal === FruitOrHerbal.FruitLiqueur && {
        fruitFlavor: [data?.fruitFlavor, Validators.required],
      }),
      // herbalFlavor:
      ...(data?.fruitOrHerbal === FruitOrHerbal.HerbalLiqueur && {
        herbalFlavor: [data?.herbalFlavor, Validators.required],
      }),
    });
  }

  onFruitOrHerbalSelected(selected?: FruitOrHerbal) {
    // fruit
    if (selected === FruitOrHerbal.FruitLiqueur) {
      this.group.addControl(
        'fruitFlavor',
        this.fb.control(null, Validators.required)
      );
      this.group.get('fruitFlavor')?.setValidators(Validators.required);
      this.group.get('fruitFlavor')?.enable();
    } else {
      this.group.removeControl('fruitFlavor');
      this.changeDetector.detectChanges();
    }

    // herbal
    if (selected === FruitOrHerbal.HerbalLiqueur) {
      this.group.addControl(
        'herbalFlavor',
        this.fb.control(null, Validators.required)
      );
      this.group.get('herbalFlavor')?.setValidators(Validators.required);
      this.group.get('herbalFlavor')?.enable();
    } else {
      this.group.removeControl('herbalFlavor');
      this.changeDetector.detectChanges();
    }
  }
}
